//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
  data: function() {
    return {
      showPassword: false
    };
  },
  computed: {
    ...mapState({
      siteComDialog: state => state.preferences.global.siteComDialog,
      siteComUserInfo: state => state.preferences.siteComUserInfo,
    }),
  },
  methods: {
    onOK: function() {
      if (this.siteComUserInfo['username'] && this.siteComUserInfo['password']) {
        this.$emit("init-siteCom-connection");
      }
      this.$store.commit("preferences/updateSiteComDialog", false);
    },
    cancelDialog: function() {
      this.$emit("cancel-to-connect-siteCom");
      this.$store.commit("preferences/updateSiteComDialog", false);
    },
    updateSiteComUserInfo: function(key, evt) {
      this.$store.commit("preferences/updateSiteComUserInfo", {key: key, value: evt})
    }
  }
};
